export const en = {
  common: {
    loading: 'Loading...',
    error: 'Error',
    retry: 'Retry',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    pay: 'Pay',
  },
  header: {
    goToBot: 'Telegram Bot',
  },
  footer: {
    telegramBot: 'Telegram Bot',
    userAgreement: 'User Agreement',
    support: 'Support',
  },
  home: {
    title: 'Buy USDT',
    subtitle: 'Fast, reliable, no fees',
  },
  payment: {
    title: 'Order Payment',
    subtitle: 'Scan the QR code or click the button to pay',
    waiting_payment: 'Click the button to proceed to payment',
    amount: 'Amount to pay',
    wallet: 'Wallet',
    network: 'Network',
    validUntil: 'Valid until',
    qrHint: 'Scan the QR code in your banking app or with your phone camera. To select a bank manually, click the "Pay" button.',
    processingHint: 'Payment is processed via SBP. After completion, return here — we will automatically process the payment and send USDT.',
    status: {
      pending: 'Pending payment',
      waiting_payment: 'Waiting for payment',
      paid: 'Paid',
      processing: 'Processing',
      completed: 'USDT sent',
      failed: 'Failed',
      cancelled: 'Cancelled',
      expired: 'Expired',
    },
    stages: {
      paid: 'Payment received',
      paid_desc: 'Confirmed by the bank',
      processing: 'Sending USDT',
      processing_desc: 'Operator is broadcasting the TRC-20 transfer',
      completed: 'USDT delivered',
      completed_desc: 'Funds credited to your wallet',
    },
    completedTitle: 'Order completed 🎉',
    completedSubtitle: 'USDT has been sent to your wallet',
    txHashLabel: 'Transaction',
    txHashView: 'View on TronScan',
    txHashPending: 'Hash will appear after network confirmation',
    etaHint: 'Usually takes 5–15 minutes',
    nightHint: 'At night (23:00–09:00 MSK) processing may take longer',
    stageHeader: 'Order processing',
    stageSubtitle: 'We received your payment and are sending USDT',
  },
};
